import { useCallback } from 'react';
import { ButtonProps } from 'antd';
import { useReactMediaRecorder } from 'react-media-recorder-2';
import { ReactComponent as IcFaceRecognition } from '@/assets/images/ic-face-recognition.svg';
import { getPreferredVideoCodec } from '@/utils/codec';
import CaptureButton from './CaptureButton';
import VideoPreview from './VideoPreview';
import Flex from '../Flex';
import VideoOverlay from './VideoOverlay';

export interface VideoCaptureProps {
  onApply: (mediaBloblURL: string) => void;
  sendButtonProps?: ButtonProps;
}

const VideoCapture = ({
  onApply,
  sendButtonProps = {}
}: VideoCaptureProps) => {

  const { status, clearBlobUrl, startRecording, stopRecording, mediaBlobUrl, previewStream } = useReactMediaRecorder({
    audio: false,
    video: true,
    stopStreamsOnStop: true,
    mediaRecorderOptions: {
      mimeType: getPreferredVideoCodec(),
    }
  });

  const handleStop = useCallback(() => {
    const tracks = previewStream?.getTracks() ?? [];
    for (const track of tracks) {
      if (track?.readyState === 'live') {
        track?.stop();
      }
    }
    stopRecording();
  }, [stopRecording, previewStream]);

  return (
    <Flex direction="column">
      <Flex className="relative" direction="column">
        {status === 'idle' && (
          <Flex
            direction="column"
            style={{
              top: '40%',
              left: '50%',
              transform: 'translate(-50%, -50%)'
            }}
            className="absolute text-[7rem] text-[#444]">
            <IcFaceRecognition />
          </Flex>
        )}
        {status === 'recording' &&
          <VideoOverlay />
        }
        <VideoPreview mediaBlobUrl={mediaBlobUrl} stream={previewStream} />
        <CaptureButton
          status={status}
          onApply={onApply}
          mediaBlobUrl={mediaBlobUrl}
          clearBlobUrl={clearBlobUrl}
          stopRecording={handleStop}
          startRecording={startRecording}
          sendButtonProps={sendButtonProps}
        />
      </Flex>
    </Flex>
  );
};

export default VideoCapture;
